import { ReactNode } from "react";
import SmallRocket from "static/images/SmallRocket.svg";

export const SubscriptionInfo = ({
  label,
  value,
}: {
  label: string | ReactNode;
  value: string | ReactNode;
}) => {
  return (
    <div className="t-space-y-0.5 t-w-36">
      <div className="t-text-body-sm t-text-text-30">{label}</div>
      <span className="t-text-body-sm t-text-text-60">{value}</span>
    </div>
  );
};

export const VerticalRow = () => (
  <hr className="t-rotate-90 t-w-7 t-text-surface-grey t-ml-10" />
);

export const BenefitPoint = ({
  description,
}: {
  description: string | ReactNode;
}) => {
  return (
    <div className="t-flex t-gap-2 t-items-center">
      <img src={SmallRocket} alt="SmallRocket" />
      <span className="t-text-body-sm t-text-text-60 t-font-light">
        {description}
      </span>
    </div>
  );
};
